import { enableProdMode, importProvidersFrom } from "@angular/core";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { ApiModule as VelgOrgApi } from "@husbanken/organisasjonsvelger-api";
import { appRoutes } from "./app/app.routes";
import { provideRouter } from "@angular/router";
import { ApiModule as HusbankenApplicationTemplateApi } from "../projects/api/api.module";
import { ApiModule as BrukerApi } from "@husbanken/bruker-api";
import { registerLocaleData } from "@angular/common";
import { AppConfigService } from "./app/shared/services/app-config.service";
import { UserService } from "./app/shared/services/user.service";
import { provideHbKeycloak } from "./app/shared/providers/keycloak.provider";
import { provideHbI18n } from "./app/shared/providers/i18n.provider";
import { TestService } from "./app/shared/services/test.service";
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { includeBearerTokenInterceptor } from "keycloak-angular";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideErrorHandler } from "./app/shared/providers/error.handler.provider";
import localeFrNb from "@angular/common/locales/nb";
import { provideEnvironment } from "./app/shared/providers/environment.provider";
import { provideAppConfig } from "./app/shared/providers/app-config.provider";
import { provideNgIdle } from "@ng-idle/core";

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeFrNb);

async function bootstrap(): Promise<void> {
  const appConfig = await AppConfigService.fetchAppConfig(environment);
  const keycloakConfig = await UserService.fetchKeycloakConfig(environment);

  try {
    await bootstrapApplication(AppComponent, {
      providers: [
        importProvidersFrom(BrukerApi.forRoot({ rootUrl: "proxy" }), HusbankenApplicationTemplateApi.forRoot({ rootUrl: "api" }), VelgOrgApi.forRoot({ rootUrl: "" })),
        provideHbKeycloak(keycloakConfig, { initKeycloak: !TestService.isRunningInFrontendTestContext, includeE2eTokens: TestService.isRunningInE2eTestContext, environment }),
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([includeBearerTokenInterceptor])),
        provideHbI18n({ cacheVersion: environment.version }),
        provideEnvironment(environment),
        provideAppConfig(appConfig),
        provideRouter(appRoutes),
        provideErrorHandler(),
        provideNgIdle()
      ],
    });
  } catch (error) {
    console.error("Failed to initialize the application", error);
  }
}

bootstrap();
